var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTournamentLargeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 7c0 1.031-.104 2.432-.32 4h4.82v1c0 1.752-.4 3.99-1.76 5.816-1.21 1.624-3.106 2.821-5.879 3.114-.982 1.921-2.213 3.387-3.719 3.885l.358 3.31V30h.5a3 3 0 013 3H15a3 3 0 013-3h.5v-1.875l.358-3.31c-1.506-.498-2.737-1.964-3.72-3.885-2.772-.293-4.668-1.49-5.877-3.114C7.9 15.99 7.5 13.752 7.5 12v-1h4.82C12.105 9.432 12 8.031 12 7h16zm-15.354 6H9.552c.13 1.24.517 2.553 1.312 3.621.688.924 1.729 1.727 3.324 2.12-.677-1.822-1.186-3.836-1.542-5.741zm13.166 5.742c.677-1.823 1.186-3.837 1.542-5.742h3.094c-.13 1.24-.517 2.553-1.312 3.621-.688.924-1.729 1.727-3.324 2.12z",
    fill: "#fff"
  })));
}

export default SvgTournamentLargeIcon;